export enum TenantUserJoined {
  CREATOR,
  JOINED_BY_INVITATION,
  JOINED_BY_LINK,
  JOINED_BY_PUBLIC_URL,
}
